module.exports = __webpack_public_path__ + "img/test1.6ea54933.png";